<template>
  <div class="contentArea">
    <el-input
      type="textarea"
      :autosize="{ minRows: 1, maxRows: 6 }"
      :placeholder="contentPlaceholder"
      v-model="content"
      clearable
    ></el-input>
    <el-row class="commitComment">
      <el-col :span="16">
        <el-upload
          class="uploadComment"
          ref="upload"
          action
          drag
          multiple
          :file-list="fileArray"
          :http-request="uploadFile"
          :on-remove="handleChange"
          :on-change="handleChange"
          :auto-upload="false"
        >
          <el-link :underline="false" slot="trigger" icon="el-icon-paperclip">附件</el-link>
          <div slot="tip" class="el-upload__tip"></div>
        </el-upload>
      </el-col>
      <el-col :span="8">
        <div class="btn-div">
          <el-button type="primary" size="mini" :disabled="isDisable" @click="addComment">发送</el-button>
          <el-button size="mini" @click="cancelComment">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { AddCrisitism2 } from "@/api/modules/basicData/task";
import { mapState } from "vuex";
export default {
  props: {
    MainId: String,
    Type: {
      type: [Number, String],
      default: 0
    },
    replyData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      ServerCenterIds: state => state.task.ServerCenterIds,
      createIdentity: state => state.task.createIdentity,
      contactId: state => state.user.ContactID,
      realName: state => state.task.realName,
      departmentId: state => state.user.departmentId,
      departmentName: state => state.user.departmentName,
      companyId: state => state.user.companyId,
      companyName: state => state.user.companyName,
      organizationId: state => state.user.organizationId
    })
  },
  data() {
    return {
      fileArray: [], //上传集合
      fileCollection: [], //上传集合 上传一个删除一个
      crisitisminfo: {},
      contentPlaceholder: "评论内容",
      content: "",
      loading: false,
      isDisable: false,
    };
  },
  watch: {
    replyData(newValue) {
      if (newValue.CREATEUSERNAME)
        this.contentPlaceholder = "回复" + newValue.CREATEUSERNAME;
      this.crisitisminfo = newValue;
    }
  },
  methods: {
    addComment() {
      this.isDisable = true;
      console.log("length", this.fileArray.length);
      if (this.fileArray.length > 0) this.$refs.upload.submit();
      else this._postComment();
    },
    cancelComment() {
      this.content = "";
      this.contentPlaceholder = "评论内容";
      this.crisitisminfo = {};
      this.$emit("cancelComment");
      this.$refs.upload.clearFiles();
    },
    reply(data) {
      this.contentPlaceholder = "回复" + data.CREATEUSERNAME;
      this.crisitisminfo = data;
    },
    handleChange(file, fileList) {
      console.log('handleChange',file);
      let fileList1 = this.fileArray.filter(p=>p.name==file.name);
      if(fileList1.length>0){
        this.fileCollection = [...this.fileCollection];
        this.fileArray = [...this.fileCollection];
      }else{
        this.fileCollection = [...fileList];
        this.fileArray = [...this.fileCollection];
        console.log("fileCollection", this.fileCollection);
      }
      
    },
    beforeUpload(file){
      console.log('beforeUpload',file);
      let fileList = this.fileArray.filter(p=>p.name==file.name);
      if(fileList.length>0){
        return false;
      }else{
        return true;
      }
    },
    uploadFile(param) {
      console.log("param.file", param.file);
      let index = this.fileCollection
        .map(item => item.raw.lastModified)
        .indexOf(param.lastModified);
      this.fileCollection.splice(index, 1);
      if (this.fileCollection.length === 0) {
        this._postComment();
      }
      return true;
    },
    _postComment() {
      console.log("_postComment");
      this.content=this.trim(this.content);
      if (!this.content) {
        this.$message({
          type: "warning",
          message: "请填写内容"
        });
        this.isDisable = false;
        return;
      }
      if (this.content.length>200) {
        this.$message({
          type: "warning",
          message: "评论内容过长!"
        });
        this.isDisable = false;
        return;
      }
      this.loading = true;
      const date = new Date();
      let par = {
        GUID: this.Guid(),
        CONTENT: this.textareaHtml(this.content),
        CREATETIME: date,
        CREATEUSERID: this.userId,
        CREATEUSERNAME: this.realName,
        CREATEDEPTID: this.departmentId,
        CREATEDEPTNAME: this.departmentName,
        MAINID: this.MainId,
        MAINTYPE: this.Type,
        CREATECOMPANYID: this.organizationId,
        CREATECOMPANYNAME: this.companyName
      };
      if (Object.keys(this.crisitisminfo).length > 0) {
        par.PID = this.crisitisminfo.ID;
        par.ROOTID = this.crisitisminfo.ROOTID
          ? this.crisitisminfo.ROOTID
          : this.crisitisminfo.ID;
        par.TOUSERID = this.crisitisminfo.CREATEUSERID;
        par.TOUSERNAME = this.crisitisminfo.CREATEUSERNAME;
        par.TODEPTID = this.crisitisminfo.CREATEDEPTID;
        par.TODEPTNAME = this.crisitisminfo.CREATEDEPTNAME;
        //  par.CREATEUSERNAME = this.crisitisminfo.CREATEUSERNAME;
      }

      // FormData 对象
      var form = new FormData();
      console.log("this.fileArray", this.fileArray);
      // 文件对象
      for (var i = 0; i < this.fileArray.length; i++) {
        form.append(i.toString(), this.fileArray[i].raw);
      }
      form.append("Crisitism", JSON.stringify(par));
      form.append("IsNotice", true);
      // const loading = this.$loading({
      //   lock: true
      // });
      // setTimeout(() => {
      //   loading.close();
      // }, 8000);
      AddCrisitism2(form)
        .then(result => {
          this.loading = false;
          this.fileArray = [];
          this.fileCollection = [];
          if (result === 1) {
            this.content = "";
            this.cancelComment();
            this.$emit("addComment");
            this.$message({
              type: "success",
              message: "添加评论成功。"
            });
          } else {
            this.$message({
              type: "error",
              message: "添加评论失败！"
            });
          }
          this.isDisable = false;
        })
        .catch(() => {
          this.loading = false;
          this.isDisable = false;
          });
    }
  }
};
</script>

<style scoped>
.uploadComment >>> .el-upload-list {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.uploadComment >>> .el-upload-list__item {
  width: auto;
  margin-top: 10px;
}
.uploadComment >>> .el-upload--text{
  width: 100%;
  text-align: left;
}
.uploadComment >>> .el-upload-dragger{
  width: auto;
  height: auto;
  text-align: left;
}
</style>

<style lang="scss" scoped>
.commitComment {
  display: flex;
}

.btn-div {
  text-align: right;
  margin-top: 10px;
}
</style>